import React, { memo } from "react";
import { useParams } from "react-router-dom";

import Form from "./components/form";

const CreateAndEditApk = () => {
  const { id } = useParams<any>();

  return (
    <div className="apk-container firmwares-modifi-container">
      <div className="title">
        {id ? "Cập nhật file APK" : "Tạo mới file APK"}
      </div>

      <Form id={id}/>
    </div>
  );
};

export default memo(CreateAndEditApk);
